import { getMasterData, getVehicleDocCountList, getVehicleDocDetialList } from '_services';
import { ActionPermissionModal, ButtonHeading, CommonDateRange, CrossButton, CustomPagination, CustomSelect, CustomTable, Customdropdown, Heading, SelectListButton, SelectListModal } from 'components';
import { UserContext } from 'context';
import { API, axiosInstance } from 'lib';
import { AddFundCanvas, EbillExtentionModal, EditTripOffCanvas, GstDetailModal, PaymentConfirmModal, PremiumUpgradModal, RoutePanningModal } from 'modals';
import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { constant } from 'constants/constant';
import './testing.css'
import { LuCircleCheckBig, LuRefreshCw, LuUserRound, LuWallet } from 'react-icons/lu';
import { Usabilty } from 'pages/Usablity';
import { Wallet } from 'pages/Wallet';
import { DocumentOverview, ManageSubscription } from 'pages';
import { Button, Offcanvas } from 'react-bootstrap';
import { TbBuilding } from 'react-icons/tb';
import { FaArrowTrendUp, FaChevronDown, FaRegCircleCheck, FaRegClock, FaRegStar } from 'react-icons/fa6';
import { GoCheckCircleFill } from 'react-icons/go';
import Tab from 'components/common/Tab';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FiDownload } from 'react-icons/fi';
import { PiWarningCircle } from 'react-icons/pi';
import { MdOutlineCancel } from 'react-icons/md';
import { GrDocumentText } from 'react-icons/gr';
import { IoWarningOutline } from 'react-icons/io5';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import StorageService from 'utils/StorageServices/StorageServices';
import { utils } from 'helper';
import { getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import moment from 'moment';
import { RxCross2 } from 'react-icons/rx';
import BootstrapTable from 'components/BootstrapTable';
import { AiOutlineTool } from 'react-icons/ai';





const Testing = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showRoutePlanning, setShowRoutePlanning] = useState(false);
    const [showEbillExtention, setShowEbillExtention] = useState(false);
    const [activeTab, setActiveTab] = useState(1);
    const [activeTabBtn, setActiveTabBtn] = useState(2);
    const [searchParams, setSearchParams] = useSearchParams();
    const loadingBarRef = useRef(null);
    const [docDetailList, setDocDetailList] = useState([]);
    const [activeOwnership, setActiveOwnership] = useState("1");
    const activeData = docDetailList?.[activeOwnership];
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 20;
    const [documentTypeList, setDocumentTypeList] = useState([]);
    const [showAddFund, setShowAddFund] = useState(false);
    const [showSelectListModal, setShowSelectListModal] = useState(false);
    const [showPremiumUpgrad, setShowPremiumUpgrad] = useState(false);

    const [filter, setFilter] = useState({
        limit: 20,
        offset: 1,
        search: '',
        // status: 1
    });

    const [ownershipCount, setOwnershipCount] = useState({});
    const [activeOwnershipNw, setActiveOwnershipNw] = useState("1");





    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        const postData = {};

        try {
            let response = await getMasterData(postData);
            setData(response.data);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }

    };


    const { cities } = useContext(UserContext);
    const [filteredCities, setFilteredCities] = useState([]);
    const [city, setCity] = useState([]);
    useEffect(() => {
        setFilteredCities(cities);
    }, [])



    const [selectedCity, setSelectedCity] = useState(null);


    const cities_new = [
        { label: 'New York', value: 'ny' },
        { label: 'Los Angeles', value: 'la' },
        { label: 'Chicago', value: 'ch' },
        { label: 'Houston', value: 'ho' },
        { label: 'Phoenix', value: 'ph' }
    ];

    const handleCitySelect = (city) => {
        setSelectedCity(city);
    };
    const handleCityChange = (city) => {
        setCity(city);
    };

    const SimpleColumns1 = ['Name', 'Age', 'Address',];

    const SimpleData1 = [
        {
            Name: 'John Doe',
            Age: 28,
            Address: `<div><p>123 Main St</p><p>Indore</p></div>`,
        },
        {
            Name: 'Jane Doe',
            Age: 34,
            Address: `<div><p>456 Maple Ave</p><p>jaipur</p></div>`,

        },
        {
            Name: 'Alice Johnson',
            Age: 23,
            Address: `<div><p>789 Oak St</p><p>delhi</p></div>`,

        },
    ];

    const filterableColumns1 = useMemo(() => ['Name', 'Age'], []); // Only 'Name' column is filterable for first table

    let routePlanModalProps = {
        isOpen: showRoutePlanning,
        closeModal: (e) => setShowRoutePlanning(false),
        onSubmit: (e) => setShowRoutePlanning(false),
        showModalFooter: false,
        modalMainClass: " _dashCommon_Modal _mapModal",
        modalTitle: "Route Planning",
        submitTitle: "Create Trip",
    };

    let updateListProps = {
        isOpen: showSelectListModal,
        closeModal: (e) => setShowSelectListModal(false),
        onSubmit: (e) => setShowSelectListModal(false),
        modalMainClass: " _dashCommon_Modal  _mdModal",
        headerPart: true,
        floatCrossBtn: true,
        modalTitle: "Update By",
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
    };

    let premiumUpgradeProps = {
        isOpen: showPremiumUpgrad,
        closeModal: (e) => setShowPremiumUpgrad(false),
        onSubmit: (e) => setShowPremiumUpgrad(false),
        modalMainClass: " _dashCommon_Modal  _mdModal",
        headerPart: true,
        floatCrossBtn: true,
        // modalTitle: "Update By",
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
    };

    

    const getDocumentType = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                limit: 100,
                offset: 1,
                // search: '',
            }
            const res = await getVehicleDocTypeListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.docTypes?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                        id: el?.id
                    }
                })
                setDocumentTypeList(data);
            }
        } catch (error) { }
    }

    const renderContent = () => {
        switch (activeTab) {
            case "wallet":
                return <Wallet />;
            case "usability":
                return <Usabilty />;
            case "manage":
                return <ManageSubscription />;
            case "billing":
                return <><div className='__payM_head'><h6>Billing History</h6></div></>;
            default:
                return null;
        }
    };

    // Change tab via tab ID → update URL with tab key
    const handleTabChange = (tabId) => {
        const selectedTab = constant.truckDocumentTabs.find(tab => tab.id === tabId);
        if (selectedTab) {
            setSearchParams({ t: selectedTab.value });
        }
    };

    const tabProps = {
        tabList: constant.accountTransactionTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab,
        // isActiveButton: true,
        // tabButtonName: 'Add Documents',
    };

    const tabBtnProps = {
        tabList: constant.summryDocsTabs,
        callBackTab: (e) => setActiveTabBtn(e),
        activeTab: activeTabBtn,
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const vehicleDocDetailList = async () => {
        try {
            loadingBarRef.current?.continuousStart();

            let object = {
                ...filter,
                doc_type_id: filter?.doc_type_id?.value,
                page: filter.offset,
                company_id: StorageService.getCompanyId(),
            };

            const res = await getVehicleDocDetialList(object);

            if (res?.responseCode == 200) {
                setDocDetailList(res?.data?.data);
                setOwnershipCount(res?.data?.ownershipCount);
                setTotalItems(res?.data?.total);
            }

        } finally {
            loadingBarRef.current?.complete();
        }
    };


    const getStatusUI = (status, expiry_date) => {
        switch (status) {
            case 1:
                return (
                    <div className='__vlExpireWrn_bx'>
                        <IoWarningOutline />
                        <span>Expired</span>
                    </div>
                );

            case 2:
                return (
                    <div className='__vlExpireSoon_bx'>
                        <IoIosCheckmarkCircleOutline />
                        <span>Expires soon</span>
                    </div>
                );

            case 3:
                return (
                    <div className='__vlVailid_bx'>
                        <IoIosCheckmarkCircleOutline />
                        <span>Valid</span>
                    </div>
                );

            case 4:
                return (
                    <div className='__vlNotAdd_bx'>
                        <IoWarningOutline />
                        <span>Not Added</span>
                    </div>
                );

            default:
                return "-";
        }
    };

    const [activeCustomer, setActiveCustomer] = useState("Customer1");


    const [selectedRange, setSelectedRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });


    const columns = [
        { header: "# Number", accessor: "number" },
        { header: "Voucher Date", accessor: "voucher_date" },
        { header: "Firm name", accessor: "firm_name" },
        { header: "Vendor", accessor: "vendor" },
        { header: "Total Amount", accessor: "total_amt" },
        { header: "Balance", accessor: "balance" },
        { header: "Under Approval", accessor: "under_approval" },
        { header: "Status", accessor: "status" },
        { header: "Tags", accessor: "tags" },
        { header: "Action", accessor: "action" },
    ];

    const list = [
        {
            id: 1,
            number: "BR2021-21",
            voucher_date: "24 Jun 2024",
            firm_name: "Oriental Retailers Pvt Ltd",
            vendor: "Parle Biscuit",
            total_amt: 63000,
            balance: 63000,
            under_approval: 0,
            status: "Pending",
            tags: ["MP20GA2109", "T2025-090"],
        },
        {
            id: 2,
            number: "BR2021-21",
            voucher_date: "24 Jun 2024",
            firm_name: "Oriental Retailers Pvt Ltd",
            vendor: "No Vendor",
            total_amt: 63000,
            balance: 63000,
            under_approval: 0,
            status: "Pending",
            tags: ["MP20GA2109", "T2025-090"],
        },
    ];

    const RowListData = (data = []) => {
        const navigate = useNavigate();

        return data.map((item) => ({
            _rowProps: {
                onClick: () => navigate(`/voucher-details/${item.id}`),
                style: { cursor: "pointer" },
            },

            number: <span>{item.number}</span>,

            voucher_date: <span>{item.voucher_date}</span>,

            firm_name: (
                <span
                    style={{ cursor: "pointer" }}
                    // onClick={() => navigate(`/voucher-details/${item.id}`)}
                    onClick={() => navigate(`/accounting/general_expense`)}
                >
                    {item.firm_name}
                </span>
            ),

            vendor: (
                <>
                    <div>{item.vendor}</div>
                    <small className="text-muted">Vendor Type</small>
                </>
            ),

            total_amt: <span>₹{item.total_amt.toLocaleString()}</span>,

            balance: <span>₹{item.balance.toLocaleString()}</span>,

            under_approval: <span>₹ {item.under_approval.toFixed(2)}</span>,

            status: (
                <span className='trs-status'>
                    {item.status}
                </span>
                //   <span className="badge bg-warning text-white">
                //     {item.status}
                //   </span>
            ),

            tags: (
                <div className="d-flex gap-1 flex-wrap">
                    {item.tags.map((tag, i) => (
                        <span key={i} className="tag-badge-bx">
                            {tag}
                        </span>
                    ))}
                </div>
            ),

            action: <span>⋮</span>,
        }));
    };


    const bidStatusList = [
        {
            id: 1,
            name: "All Vehicle",
            count: 0
        },
        {
            id: 2,
            name: "On Trip",
            count: 0
        },
        {
            id: 3,
            name: "Available",
            count: 0
        },
        {
            id: 4,
            name: "Maintenance",
            count: 0
        }
    ];


    const runningStatusList = [
        {
            id: 1,
            name: "On Time",
            count: 0
        },
        {
            id: 2,
            name: "Running Late",
            count: 0
        },
        {
            id: 3,
            name: "Running Before",
            count: 0
        }
    ];

    const upCommingPlanList = [
        {
            id: 1,
            name: "Planned",
            count: 0
        },
        {
            id: 2,
            name: "Not Planned",
            count: 0
        }
    ]

    const lastUpdateList = [
        {
            id: 1,
            name: "All Updates",
            count: 0
        },
        {
            id: 2,
            name: "More Than 1 Hours",
            count: 0
        },
        {
            id: 3,
            name: "More Than 3 Hours",
            count: 0
        },
        {
            id: 4,
            name: "More Than 6 Hours",
            count: 0
        },
        {
            id: 5,
            name: "More Than 12 Hours",
            count: 0
        }
    ]


    return (
        <>
            {/* VEHICLE PLANNING */}

            <div className='__vhlPlanning_mainBx'>
                <ButtonHeading title="Vehicle Planning" />

                {/* <button onClick={() => setShowSelectListModal(true)}>GST Details</button> */}
                
                <div className='p-3'><button className='btn btn-primary' onClick={() => setShowPremiumUpgrad(true)}>Upgrade to Premium</button></div>

                {/* <div className="_indentView_flx">
                    <div className="indentSide_bx">
                        <div className="_indtsLs_flx">
                            <div className="_indtsList">
                                <h5>Vehicle Status</h5>
                                <div className="_bidsLs_flx">
                                    {bidStatusList.map((bid) => {
                                        return (
                                            <div className="_bidsList" key={bid.id}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={`bid-${bid.id}`}
                                                    type="radio"
                                                    name="bidList"
                                                />
                                                <label htmlFor={`bid-${bid.id}`}>
                                                    <span>{bid.name}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Running Status</h5>
                                <div className="_bidsLs_flx">
                                    {runningStatusList.map((runStat) => {
                                        return (
                                            <div className="_bidsList" key={runStat.id}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={`run-${runStat.id}`}
                                                    type="radio"
                                                    name="runList"
                                                />
                                                <label htmlFor={`run-${runStat.id}`}>
                                                    <span>{runStat.name}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Upcoming Plan</h5>
                                <div className="_bidsLs_flx">
                                    {upCommingPlanList.map((upcom) => {
                                        return (
                                            <div className="_bidsList" key={upcom.id}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={`upCom-${upcom.id}`}
                                                    type="radio"
                                                    name="upComList"
                                                />
                                                <label htmlFor={`upCom-${upcom.id}`}>
                                                    <span>{upcom.name}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Last updated</h5>
                                <div className="_bidsLs_flx">
                                    {lastUpdateList.map((lastUp) => {
                                        return (
                                            <div className="_bidsList" key={lastUp.id}>
                                                <input
                                                    className="form-check-input _avPointer"
                                                    id={`lastUp-${lastUp.id}`}
                                                    type="radio"
                                                    name="lastUpList"
                                                />
                                                <label htmlFor={`lastUp-${lastUp.id}`}>
                                                    <span>{lastUp.name}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="_indtsList">
                                <h5>Updated By</h5>

                                <div className='_optFilts' style={{ marginTop: '8px', paddingLeft: '15px' }}>
                                    <SelectListButton onClick={() => setShowSelectListModal(true)} selectTxt={"All Users"} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="_indTabl_right">
                        <div className="_indentTable _planLTable">
                            <div className="accordion" id="indentTableAccordian">
                                <table className="__tPlain_table">
                                    <thead>
                                        <tr>
                                            <th>Vehicle Number</th>
                                            <th>Route Details</th>
                                            <th>Status Date</th>
                                            <th>Due Date</th>
                                            <th>Available Date</th>
                                            <th>Manual Remarks</th>
                                            <th>Updated By</th>
                                            <th>Upcoming Plan</th>
                                            <th>GPS Location</th>
                                            <th>Driver Name</th>
                                            <th>Vehicle Group</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className='_vlPln_div'><p>TN 02 CD 5678</p></div>
                                            </td>

                                            <td>
                                                <div className='_rdPlan_div'>
                                                    <div className='__vpOnTrip_st'><FaArrowTrendUp /> On Trip</div>
                                                    <p>Indore- Bhopal</p>
                                                    <span>T2026-01</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_stPlan_div'>
                                                    <p>2d | 3h | 30m ago</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_duPlan_div'>
                                                    <p>12-Jun-2026</p>
                                                    <p>5:30 PM</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_availPlan_div _lateAvail'>
                                                    <p>13-Jun-2026</p>
                                                    <p>6:30 PM</p>
                                                    <span>Late by</span>
                                                    <span>2 D | 1 H | 40M</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_manPlan_div'>
                                                    <p>Vehicle Running Late</p>
                                                    <p>Due to Traffice</p>
                                                    <Link to='/' style={{ marginTop: '4px' }}>Update Status</Link>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_updPlan_div'>
                                                    <p>Ajay Jain</p>
                                                    <p>1h ago</p>
                                                </div>
                                            </td>

                                            <td className='_upComPlan_div'>
                                                <button className='add_planVhl'>+ Add Plan</button>
                                            </td>

                                            <td>
                                                <div className='_gpsPlan_div'>
                                                    <p>Rajwada, Indore</p>
                                                    <p className='_vpText_warn'>Stopped since 2h | 10m</p>
                                                    <span className='_vpText_danger'>2d | 3h | 30m ago</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_drvPlan_div'>
                                                    <p>Ram Kumar</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_vlGrpPlan_div'>
                                                    <p>Group A</p>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='_vlPln_div'><p>TN 03 CD 5678</p></div>
                                            </td>

                                            <td>
                                                <div className='_rdPlan_div'>
                                                    <div className='__vpAvail_st'><FaRegCircleCheck /> Available</div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_stPlan_div'>
                                                    <p>2d | 3h | 30m ago</p>
                                                </div>
                                            </td>

                                            <td></td>

                                            <td>
                                                <div className='_availPlan_div _onTimeAvail'>
                                                    <p>13-Jun-2026</p>
                                                    <p>6:30 PM</p>
                                                    <span>Available Since</span>
                                                    <span>2 D | 1 H | 40 M</span>
                                                </div>
                                            </td>

                                            <td>
                                                <button className='add_planVhl'>+ Update Status</button>
                                            </td>

                                            <td>
                                                <div className='_updPlan_div'>
                                                    <p>Rohit Ghorawat</p>
                                                    <p>2d | 3h | 30m ago</p>
                                                </div>
                                            </td>

                                            <td className='_upComPlan_div'>
                                                <p>Parle Biscuit</p>
                                                <p>Indore- Bhopal- Ujjain</p>
                                                <span>13-Jun-2025 | 6:30 PM</span>
                                            </td>

                                            <td>
                                                <div className='_gpsPlan_div'>
                                                    <p>Rajwada, Indore</p>
                                                    <span>1m ago</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_drvPlan_div'>
                                                    <p>Ram Kumar</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_vlGrpPlan_div'>
                                                    <p>Group B</p>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='_vlPln_div'><p>TN 04 CD 5678</p></div>
                                            </td>

                                            <td>
                                                <div className='_rdPlan_div'>
                                                    <div className='__vpOnTrip_st'><FaArrowTrendUp /> On Trip</div>
                                                    <p>Indore- Bhopal</p>
                                                    <span>T2026-01</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_stPlan_div'>
                                                    <p>2d | 3h | 30m ago</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_duPlan_div'>
                                                    <p>12-Jun-2026</p>
                                                    <p>5:30 PM</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_availPlan_div _onTimeAvail'>
                                                    <p>13-Jun-2026</p>
                                                    <p>6:30 PM</p>
                                                    <span>On Time</span>
                                                    <span>2 D | 1 H | 40M</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_manPlan_div'>
                                                    <p>Vehicle Running Late</p>
                                                    <p>Due to Traffice</p>
                                                    <Link to='/' style={{ marginTop: '4px' }}>Update Status</Link>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_updPlan_div'>
                                                    <p>Ajay Jain</p>
                                                    <p>1h ago</p>
                                                </div>
                                            </td>

                                            <td className='_upComPlan_div'>
                                                <button className='add_planVhl'>+ Add Plan</button>
                                            </td>

                                            <td>
                                                <div className='_gpsPlan_div'>
                                                    <p>Rajwada, Indore</p>
                                                    <span className=''>1m ago</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_drvPlan_div'>
                                                    <p>Ram Kumar</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_vlGrpPlan_div'>
                                                    <p>Group A</p>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='_vlPln_div'><p>TN 03 CD 5678</p></div>
                                            </td>

                                            <td>
                                                <div className='_rdPlan_div'>
                                                    <div className='__vpMainten_st'><AiOutlineTool /> Maintenance</div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_stPlan_div'>
                                                    <p>2d | 3h | 30m ago</p>
                                                </div>
                                            </td>

                                            <td></td>

                                            <td>
                                                <div className='_availPlan_div _onMaintenAvail'>
                                                    <p>13-Jun-2026</p>
                                                    <p>6:30 PM</p>
                                                    <span>Available by</span>
                                                    <span>2 D | 1 H | 40M</span>
                                                </div>
                                            </td>

                                            <td>
                                                <button className='add_planVhl'>+ Update Status</button>
                                            </td>

                                            <td>
                                                <div className='_updPlan_div'>
                                                    <p>Rohit Ghorawat</p>
                                                    <p>2d | 3h | 30m ago</p>
                                                </div>
                                            </td>

                                            <td className='_upComPlan_div'>
                                                <button className='add_planVhl'>+ Add Plan</button>
                                            </td>

                                            <td>
                                                <div className='_gpsPlan_div'>
                                                    <p>Rajwada, Indore</p>
                                                    <span>1m ago</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_drvPlan_div'>
                                                    <p>Ram Kumar</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_vlGrpPlan_div'>
                                                    <p>Group B</p>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className='_vlPln_div'><p>TN 04 CD 5678</p></div>
                                            </td>

                                            <td>
                                                <div className='_rdPlan_div'>
                                                    <div className='__vpOnTrip_st'><FaArrowTrendUp /> On Trip</div>
                                                    <p>Indore- Bhopal</p>
                                                    <span>T2026-01</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_stPlan_div'>
                                                    <p>2d | 3h | 30m ago</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_duPlan_div'>
                                                    <p>12-Jun-2026</p>
                                                    <p>5:30 PM</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_availPlan_div _onTimeAvail'>
                                                    <p>13-Jun-2026</p>
                                                    <p>6:30 PM</p>
                                                    <span>Running Before</span>
                                                    <span>2 D | 1 H | 40M</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_manPlan_div'>
                                                    <p>Vehicle Running Late</p>
                                                    <p>Due to Traffice</p>
                                                    <Link to='/' style={{ marginTop: '4px' }}>Update Status</Link>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_updPlan_div'>
                                                    <p>Ajay Jain</p>
                                                    <p>1h ago</p>
                                                </div>
                                            </td>

                                            <td className='_upComPlan_div'>
                                                <button className='add_planVhl'>+ Add Plan</button>
                                            </td>

                                            <td>
                                                <div className='_gpsPlan_div'>
                                                    <p>Rajwada, Indore</p>
                                                    <span className=''>1m ago</span>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_drvPlan_div'>
                                                    <p>Ram Kumar</p>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='_vlGrpPlan_div'>
                                                    <p>Group A</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="paginationFt_avt ">
                            {" "}
                            <CustomPagination
                                totalItems={6}
                                itemsPerPage={10}
                            />
                        </div>
                    </div>
                </div> */}

            </div>

            {showSelectListModal && <GstDetailModal {...updateListProps} />}

            {showPremiumUpgrad && <PremiumUpgradModal {...premiumUpgradeProps} />}

            

            {/* VEHICLE PLANNING */}
        </>
    );
};

export default Testing;
